var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "form",
      staticClass: "contact-form form max-w-[30rem]",
      class: { processing: _vm.processing },
    },
    [
      !_vm.submitted
        ? _c("ValidationObserver", {
            ref: "observer",
            attrs: { tag: "form" },
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.submit("/api/contact")
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (obs) {
                    return [
                      _c("ValidationProvider", {
                        ref: "first_name",
                        attrs: {
                          vid: "first_name",
                          rules: "required|min:2",
                          name: _vm.translations.first_name,
                          slim: true,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (props) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "relative mb-md",
                                      class: props.classes,
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "text-md mb-xs inline-block",
                                          attrs: { for: "first_name" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.translations.first_name)
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.formData.first_name,
                                            expression: "formData.first_name",
                                          },
                                        ],
                                        staticClass:
                                          "form__input form__input--lg",
                                        attrs: {
                                          type: "text",
                                          id: "first_name",
                                          placeholder:
                                            _vm.translations
                                              .first_name_placeholder,
                                        },
                                        domProps: {
                                          value: _vm.formData.first_name,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.formData,
                                              "first_name",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      props.errors && props.errors.length
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "text-red text-xs leading-none inline-block",
                                            },
                                            [_vm._v(_vm._s(props.errors[0]))]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _vm._v(" "),
                      _c("ValidationProvider", {
                        ref: "name",
                        attrs: {
                          vid: "name",
                          rules: "required|min:2",
                          name: _vm.translations.name,
                          slim: true,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (props) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "relative mb-md",
                                      class: props.classes,
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "text-md mb-xs inline-block",
                                          attrs: { for: "name" },
                                        },
                                        [_vm._v(_vm._s(_vm.translations.name))]
                                      ),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.formData.name,
                                            expression: "formData.name",
                                          },
                                        ],
                                        staticClass:
                                          "form__input form__input--lg",
                                        attrs: {
                                          type: "text",
                                          id: "name",
                                          placeholder:
                                            _vm.translations.name_placeholder,
                                        },
                                        domProps: { value: _vm.formData.name },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.formData,
                                              "name",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      props.errors && props.errors.length
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "text-red text-xs leading-none inline-block",
                                            },
                                            [_vm._v(_vm._s(props.errors[0]))]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _vm._v(" "),
                      _c("ValidationProvider", {
                        ref: "email",
                        attrs: {
                          vid: "email",
                          rules: "required|email",
                          name: _vm.translations.email,
                          slim: true,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (props) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "relative mb-md",
                                      class: props.classes,
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "text-md mb-xs inline-block",
                                          attrs: { for: "email" },
                                        },
                                        [_vm._v(_vm._s(_vm.translations.email))]
                                      ),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.formData.email,
                                            expression: "formData.email",
                                          },
                                        ],
                                        staticClass:
                                          "form__input form__input--lg",
                                        attrs: {
                                          type: "email",
                                          id: "email",
                                          placeholder:
                                            _vm.translations.email_placeholder,
                                        },
                                        domProps: { value: _vm.formData.email },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.formData,
                                              "email",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      props.errors && props.errors.length
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "text-red text-xs leading-none inline-block",
                                            },
                                            [_vm._v(_vm._s(props.errors[0]))]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _vm._v(" "),
                      _c("ValidationProvider", {
                        ref: "phone",
                        attrs: {
                          vid: "phone",
                          rules: {
                            required: true,
                            regex:
                              /((?:\+|00)[17](?: |\-)?|(?:\+|00)[1-9]\d{0,2}(?: |\-)?|(?:\+|00)1\-\d{3}(?: |\-)?)?(0\d|\([0-9]{3}\)|[1-9]{0,3})(?:((?: |\-)[0-9]{2}){4}|((?:[0-9]{2}){4})|((?: |\-)[0-9]{3}(?: |\-)[0-9]{4})|([0-9]{7}))/,
                          },
                          name: _vm.translations.phone,
                          slim: true,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (props) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "relative mb-md",
                                      class: props.classes,
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "text-md mb-xs inline-block",
                                          attrs: { for: "phone" },
                                        },
                                        [_vm._v(_vm._s(_vm.translations.phone))]
                                      ),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.formData.phone,
                                            expression: "formData.phone",
                                          },
                                        ],
                                        staticClass:
                                          "form__input form__input--lg",
                                        attrs: {
                                          type: "text",
                                          id: "phone",
                                          placeholder:
                                            _vm.translations.phone_placeholder,
                                        },
                                        domProps: { value: _vm.formData.phone },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.formData,
                                              "phone",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      props.errors && props.errors.length
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "text-red text-xs leading-none inline-block",
                                            },
                                            [_vm._v(_vm._s(props.errors[0]))]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _vm._v(" "),
                      _c("ValidationProvider", {
                        ref: "comment",
                        attrs: {
                          vid: "comment",
                          rules: "required|min:5",
                          name: _vm.translations.comment,
                          slim: true,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (props) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "relative mb-md",
                                      class: props.classes,
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "text-md mb-xs inline-block",
                                          attrs: { for: "comment" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.translations.message)
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("textarea", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.formData.comment,
                                            expression: "formData.comment",
                                          },
                                        ],
                                        staticClass:
                                          "form__input form__input--textarea form__input--lg",
                                        attrs: {
                                          id: "comment",
                                          placeholder:
                                            _vm.translations
                                              .message_placeholder,
                                        },
                                        domProps: {
                                          value: _vm.formData.comment,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.formData,
                                              "comment",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      props.errors && props.errors.length
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "text-red text-xs leading-none inline-block mb-2",
                                            },
                                            [_vm._v(_vm._s(props.errors[0]))]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _vm._v(" "),
                      _c("ValidationProvider", {
                        ref: "newsletter",
                        attrs: {
                          vid: "newsletter",
                          name: _vm.translations.newsletter,
                          slim: true,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (props) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "relative mb-md",
                                      class: props.classes,
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "form__checkbox form__checkbox--filled-dark flex",
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.formData.newsletter,
                                                expression:
                                                  "formData.newsletter",
                                              },
                                            ],
                                            attrs: {
                                              type: "checkbox",
                                              id: "newsletter",
                                              placeholder:
                                                _vm.translations.newsletter,
                                            },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.formData.newsletter
                                              )
                                                ? _vm._i(
                                                    _vm.formData.newsletter,
                                                    null
                                                  ) > -1
                                                : _vm.formData.newsletter,
                                            },
                                            on: {
                                              change: function ($event) {
                                                var $$a =
                                                    _vm.formData.newsletter,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = null,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      _vm.$set(
                                                        _vm.formData,
                                                        "newsletter",
                                                        $$a.concat([$$v])
                                                      )
                                                  } else {
                                                    $$i > -1 &&
                                                      _vm.$set(
                                                        _vm.formData,
                                                        "newsletter",
                                                        $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          )
                                                      )
                                                  }
                                                } else {
                                                  _vm.$set(
                                                    _vm.formData,
                                                    "newsletter",
                                                    $$c
                                                  )
                                                }
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("span", {
                                            staticClass: "translate-y-[6px]",
                                            on: {
                                              click: _vm.checkboxSpanClicked,
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            { attrs: { for: "newsletter" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.translations.newsletter
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      props.errors && props.errors.length
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "text-red text-xs leading-none inline-block mb-2",
                                            },
                                            [_vm._v(_vm._s(props.errors[0]))]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn--primary btn--filled",
                          attrs: { type: "submit", disabled: _vm.processing },
                        },
                        [
                          _c("span", [_vm._v(_vm._s(_vm.translations.submit))]),
                          _vm._v(" "),
                          _vm.processing
                            ? _c("i", {
                                staticClass:
                                  "fa-regular fa-spinner-third animate-spin",
                              })
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.compiledErrors && _vm.compiledErrors.length
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "error text-red text-xs leading-none inline-block mb-5",
                            },
                            [_vm._v(_vm._s(_vm.compiledErrors[0]))]
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ],
              null,
              false,
              1994410693
            ),
          })
        : _c("div", [
            _c("p", { staticClass: "success-message" }, [
              _vm._v(_vm._s(_vm.translations.success_message)),
            ]),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }